var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    { attrs: { alignItems: "center" } },
    [
      !_vm.noIcon
        ? _c("ItpIcon", {
            staticClass: "mr-2",
            attrs: {
              name: _vm.$config.register.icon,
              spacing: "mr-3",
              title: _vm._f("pgettext")("Register", "Register")
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ItpBox",
        { attrs: { direction: "column" } },
        [
          _vm.item.version
            ? _c("div", { staticClass: "mr-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.item.version.name) +
                    " · " +
                    _vm._s(_vm.item.version.company_name) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ItpBox",
            { attrs: { alignItems: "center" } },
            [
              _c("ItpText", {
                staticClass: "mr-2",
                attrs: { strong: "", text: _vm.item.entry_number }
              }),
              _vm._v(" "),
              _c("ItpLink", {
                attrs: { icon: _vm.$config.externalLinkIcon },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_3601807637515735_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }